import { CommissionTransactionTypes } from 'constants/commissionTransactionTypes';
import { FINANCE_ROLES, Role } from 'constants/roles';

import { usePermissions } from 'hooks/usePermissions';
import { useGetList } from 'react-admin';

const FORBIDDEN_LADDER_TRANSACTION_TYPES = [
  CommissionTransactionTypes.Refund,
  CommissionTransactionTypes.Chargeback,
];

export function useIsAllowedLadder(transactionTypes: string[]) {
  const { isHaveRole } = usePermissions();

  const hasLadderAccess = isHaveRole([Role.Admin, ...FINANCE_ROLES]);

  const { data } = useGetList('transaction_types/commission/list');
  const notAllowedTypes = data
    ?.filter((v) => FORBIDDEN_LADDER_TRANSACTION_TYPES.includes(v.alias))
    ?.map((v) => v.id);

  const isAllowedLadder = !transactionTypes?.some((type: string) =>
    notAllowedTypes?.includes(type),
  );
  return {
    canUseLadder: hasLadderAccess,
    isAllowedLadder,
  };
}
